<template>
    <div id="mobile-content-module-root-container" class="relative mobile-item shadow flex flex-col vld-parent" @click="openPlayer">
        <!--<div id="actual-mobile-content-module">-->
            <!--<div class="relative mobile-item bg-green-500 shadow p-2" @click="openPlayer">-->

        <loading :active="componentLoading" :is-full-page="false" :can-cancel="true"></loading>

                <!--<img :src="image" alt="" height="135" />-->
                <img :src="image" alt="" height="135" style="object-fit: cover;" @load="loadingFinished" />
                <!--<img v-else src="/images/default_thumbnail.jpg" alt="" height="135" />-->
                <!--<img v-else :src="default_thumbnail" alt="" height="135" />-->

                <!--<p class="text-theme-main hover:text-theme-title pl-4 pr-4 pt-4 pb-4 leading-tight font-bold h-20 bg-theme-level4" v-text="title"></p>-->
                <p class="text-theme-main hover:text-theme-title pl-4 pr-4 pt-4 pb-4 leading-tight font-bold bg-theme-level4" v-text="title" style="max-height: 88px;"></p>

                <div class="flex-1 bg-theme-level4"></div>

                <span class="px-4 pb-4 text-xs text-theme-discrete flex flex-row items-center bg-theme-level4">
                                <i class="material-icons mr-2" style="font-size: 16px;">event_note</i>
                                <span class="flex-1"><span v-text="date"></span>, <span v-text="time"></span></span>
                                <!--<i id="module-options-button" class="relative material-icons text-theme-muted hover:text-theme-discrete" style="font-size: 26px;right: -10px;">more_vert</i>-->
                            </span>

                <div id="media-duration"
                     class="absolute bg-theme-dropdowndismissal w-32 h-8
                                        text-theme-control-label text-center pt-2 opacity-75
                                        border border-theme-control-label rounded-md"
                     style="top: 32%; right: 12px;" v-text="duration"></div>

            <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {

        components: {
            Loading
        },

        data() {
            return {
                isLoadingContent: true,
                componentLoading: true,
                contentId: this.content.id,
                /*image: process.env.MIX_CLOUDFRONT_DNSNAME + this.content.thumbnail_url,*/
                title: this.content.title,
                date: (this.content.publish_date).split(' ')[0],
                time: (this.content.publish_date).split(' ')[1],
                duration: this.content.media_duration,
            }
        },

        props: [
            'content',
            'currentlocale',
            'legacy',
            'default_thumbnail'
        ],

        computed: {

            image() {
                if(this.legacy) {
                    if(this.content.thumbnail_url !== '') {
                        return process.env.MIX_LEGACY_THUMBNAILS_CLOUDFRONT_DNSNAME + this.content.thumbnail_url;
                    } else {
                        return this.default_thumbnail
                    }
                } else {
                    return process.env.MIX_CLOUDFRONT_DNSNAME + this.content.thumbnail_url;
                }
            }

        },

        methods: {

            loadingFinished() {
                this.componentLoading=false
            },

            openPlayer() {
                /*console.log('Firing up the player... with: ' + JSON.stringify(this.content));*/
                Event.fire('showPlayerMobile', { language: this.currentlocale, data: this.content });
            }
        },

    }
</script>

<style scoped>

    img {
        width: 100%;
        height: 135px;
    }

    .mobile-hs > li,
    .mobile-item {
        scroll-snap-align: center;
        /*padding: calc(var(--gutter) / 2 * 1.5);*/
        display: flex;
        flex-direction: column;
        justify-content: start;
        /*align-items: center;*/
        /*background: #fff;*/
        border-radius: 12px;
        overflow: hidden;
    }

</style>
